import i18n from 'i18next';
import moment from 'moment';


export const campusTitle = (job) => {
  if (job && job.locations) {
    if (Array.isArray(job.locations)) {
      return job.locations.length === 3 ?
        i18n.t('all_available_location')
        : job.locations.map(loc => loc.name).join(', ');
    }
    return job.locations;
  }
  return i18n.t('no_data');
};


// Return string - {{date}} at {{time}};
export const parseDate = date => (
  date && moment(date).isValid() ? i18n.t('date_time_1', {
    date: moment(date).format('DD.MM.YYYY'),
    time: moment(date).format('HH:mm')
  })
    : i18n.t('no_data')
);


export const getCollSpan = (goals, checkKeys = ['Cancel', 'SMS', 'Push', 'Email']) => {
  let collSpan = 5;
  if (Array.isArray(goals) && goals[0]) {
    checkKeys.forEach(cellType => {
      if (Array.isArray(goals[0].logs) && goals[0].logs.find(log => log.type === cellType)) {
        collSpan += 1;
      }
    });
  }
  return collSpan;
};